import { AutogenModelSalespersonReassign, AutogenRowSalespersonReassign } from "./autogen/AutogenModelSalespersonReassign";

export class ModelSalespersonReassign extends AutogenModelSalespersonReassign<RowSalespersonReassign> {
	constructor() {
		super(RowSalespersonReassign);
	}
}

export class RowSalespersonReassign extends AutogenRowSalespersonReassign {
}